<template>
  <el-input-number
    class="table-sort-input"
    :value="value"
    :min="0"
    :step="1"
    size="mini"
    controls-position="right"
    @change="$emit('change', $event)"
  />
</template>

<script>
export default {
  name: "SortInput",
  props: {
    value: { type: Number, default: 0 }
  }
};
</script>

<style scoped>
.table-sort-input {
  width: 100%;
}
</style>
